import styles from './FooterSecondaryNavMobile.scss';

import React, { FC } from 'react';

import { ExternalLink, InternalLink, LinkSet } from 'src/api/contentful/contentTypes.cloverdotcom';
import { SimpleArrowAccordionV2 } from 'src/components/Accordion/SimpleArrowAccordionV2/SimpleArrowAccordionV2';
import { AccordionItem } from 'src/components/Accordion/models';
import { Grid } from 'src/components/Grid/Grid';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { componentKeyV2 } from 'src/utils/ComponentKeyV2';

import { TermsAndConditions } from '../../TermsAndConditions/TermsAndConditions';
import { FooterLegalLinks } from '../FooterLegalLinks/FooterLegalLinks';
import { FooterLinkSet } from '../FooterLinkSet/FooterLinkSet';
import { FooterLocalePicker } from '../FooterLocalePicker/FooterLocalePicker';
import { FooterSocialLinks } from '../FooterSocialLinks/FooterSocialLinks';

const makeAccordionSections = (entries: Array<FlatEntry<LinkSet>>): AccordionItem[] => (
  entries.map((entry, index) => ({
    id: componentKeyV2(entry, index),
    title: entry.title,
    body: (
      <FooterLinkSet
        entry={{ items: entry.items }}
        listClassName={styles.list}
        listItemClassName={styles.listItem}
      />
    ),
  }))
);

export interface FooterSecondaryNavMobileProps {
  items?: Array<FlatEntry<LinkSet>>;
  legalLinks?: Array<FlatEntry<ExternalLink | InternalLink>>;
  socialLinks?: Array<FlatEntry<ExternalLink>>;
}

export const FooterSecondaryNavMobile: FC<FooterSecondaryNavMobileProps> = ({
  items = [],
  socialLinks = [],
  legalLinks = [],
}) => {
  return (
    <>
      {!!items.length && (
        <Grid item xs={12}>
          <div className={styles.accordion}>
            <SimpleArrowAccordionV2 bodyClassName={styles.accordionBody} items={makeAccordionSections(items)} />
          </div>
        </Grid>
      )}
      {!!socialLinks.length && (
        <Grid item xs={12}>
          <FooterSocialLinks items={socialLinks} className={styles.socialLinks} />
        </Grid>
      )}
      <Grid item xs={12}>
        <TermsAndConditions className={styles.disclosureBlurbWrapper} />
      </Grid>
      {!!legalLinks.length && (
        <Grid item xs={12}>
          <FooterLegalLinks items={legalLinks} className={styles.legalLinks} />
        </Grid>
      )}
      <Grid item xs={12}>
        <FooterLocalePicker className={styles.localePicker} />
      </Grid>
    </>
  );
};

FooterSecondaryNavMobile.displayName = 'FooterSecondaryNavMobile';
